import { render, staticRenderFns } from "./OrganicStructurePg.vue?vue&type=template&id=56447390&scoped=true&"
import script from "./OrganicStructurePg.vue?vue&type=script&lang=js&"
export * from "./OrganicStructurePg.vue?vue&type=script&lang=js&"
import style0 from "./OrganicStructurePg.vue?vue&type=style&index=0&id=56447390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56447390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
